import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSwap12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowSwap12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.897 4.897a.5.5 0 0 0 .707.707l1.768-1.768.353-.353-.353-.354-1.768-1.768a.5.5 0 0 0-.707.707L9.829 3H1.12a.5.5 0 0 0 0 1h8.672zM3.104 7.084 2.188 8H11a.5.5 0 0 1 0 1H2.191l.913.913a.5.5 0 1 1-.707.707L.629 8.852.275 8.5l.354-.354 1.768-1.768a.5.5 0 0 1 .707.707"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSwap12);
